import React from 'react'
import { Button, Box } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { useTranslation } from 'react-i18next'

interface IAddNewButtonProps {
  text: string
  handleAddNew?: () => void
}

// eslint-disable-next-line react/prop-types
export const AddNewButtonForContactOrderList: React.VFC<IAddNewButtonProps> = ({
  handleAddNew,
  text,
}): JSX.Element => {
  const { t } = useTranslation()

  return (
    <Box position={'relative'}>
      <Button
        variant="contained"
        size="medium"
        startIcon={<AddIcon sx={{ fontSize: 14 }} />}
        onClick={handleAddNew}
        sx={{
          position: 'absolute',
          top: '-64px',
          left: '1180px'
        }}
      >
        {t(text)}
      </Button>
    </Box>
  )
}
